import { MagnifyingGlassIcon, XIcon } from "@phosphor-icons/react";
import { useState } from "react";
import settings from "./settings";

const SearchBar = ({ query, setQuery, placeholder = "" }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // Settings'ten değerleri al
  const backgroundColor = settings.backgroundColor.value;
  const borderColor = settings.borderColor.value;
  const focusBorderColor = settings.focusBorderColor.value;
  const textColor = settings.textColor.value;
  const placeholderColor = settings.placeholderColor.value;
  const searchIconColor = settings.searchIconColor.value;
  const clearIconColor = settings.clearIconColor.value;
  const clearIconHoverColor = settings.clearIconHoverColor.value;
  const shadowColor = settings.shadowColor.value;
  const paddingX = settings.paddingX.value + "px";
  const paddingY = settings.paddingY.value + "px";
  const marginX = settings.marginX.value + "px";
  const marginY = settings.marginY.value + "px";
  const borderRadius = settings.borderRadius.value + "px";
  const borderWidth = settings.borderWidth.value + "px";
  const inputFontSize = settings.inputFontSize.value + "px";
  const inputPaddingY = settings.inputPaddingY.value + "px";
  const inputMarginLeft = settings.inputMarginLeft.value + "px";
  const inputPaddingRight = settings.inputPaddingRight.value + "px";
  const searchIconSize = settings.searchIconSize.value;
  const clearIconSize = settings.clearIconSize.value;
  const clearButtonPadding = settings.clearButtonPadding.value + "px";
  const clearButtonRight = settings.clearButtonRight.value + "px";
  const shadowBlur = settings.shadowBlur.value + "px";
  const animationDuration = settings.animationDuration.value + "ms";
  const showShadow = settings.showShadow.value;
  const showClearButton = settings.showClearButton.value;
  const focusEffects = settings.focusEffects.value;
  const hoverEffects = settings.hoverEffects.value;
  const fullWidth = settings.fullWidth.value;
  const clearButtonBackground = settings.clearButtonBackground.value;
  const inputFontWeight = settings.inputFontWeight.value;
  const inputTextAlign = settings.inputTextAlign.value;
  const searchIconWeight = settings.searchIconWeight.value;
  const clearIconWeight = settings.clearIconWeight.value;

  const getBoxShadow = () => {
    if (!showShadow) return "none";
    return `0 2px ${shadowBlur} ${shadowColor}`;
  };

  const getCurrentBorderColor = () => {
    if (focusEffects && isFocused) return focusBorderColor;
    return borderColor;
  };

  const getCurrentIconColor = () => {
    if (hoverEffects && isHovered) return clearIconHoverColor;
    return clearIconColor;
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        border: `${borderWidth} solid ${getCurrentBorderColor()}`,
        borderRadius: borderRadius,
        paddingLeft: paddingX,
        paddingRight: paddingX,
        paddingTop: paddingY,
        paddingBottom: paddingY,
        backgroundColor: backgroundColor,
        marginLeft: fullWidth ? "0" : marginX,
        marginRight: fullWidth ? "0" : marginX,
        marginTop: marginY,
        marginBottom: marginY,
        position: "relative",
        boxShadow: getBoxShadow(),
        transition: focusEffects ? `all ${animationDuration} ease` : "none",
        width: fullWidth ? "100%" : "auto",
      }}
    >
      <MagnifyingGlassIcon
        color={searchIconColor}
        size={searchIconSize}
        weight={searchIconWeight}
      />
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholder}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        style={{
          flex: 1,
          outline: "none",
          border: "none",
          backgroundColor: "transparent",
          marginLeft: inputMarginLeft,
          fontSize: inputFontSize,
          fontWeight: inputFontWeight,
          paddingTop: inputPaddingY,
          paddingBottom: inputPaddingY,
          paddingRight: inputPaddingRight,
          color: textColor,
          textAlign: inputTextAlign,
          "::placeholder": {
            color: placeholderColor,
          },
        }}
      />
      <style>
        {`
          input::placeholder {
            color: ${placeholderColor} !important;
          }
        `}
      </style>
      {query && showClearButton && (
        <button
          type="button"
          onClick={() => setQuery("")}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          tabIndex={-1}
          style={{
            position: "absolute",
            right: clearButtonRight,
            top: "50%",
            transform: "translateY(-50%)",
            padding: clearButtonPadding,
            color: getCurrentIconColor(),
            backgroundColor: clearButtonBackground,
            border: "none",
            cursor: "pointer",
            zIndex: 10,
            transition: hoverEffects ? `all ${animationDuration} ease` : "none",
            borderRadius: "50%",
          }}
        >
          <XIcon size={clearIconSize} weight={clearIconWeight} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
